
import { Radio } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

{ Group } = Radio

export default RadioInput = ({
  form
  item
  label
  options
  config
}) ->

  {
    vertical
  } = config if config

  selectOptions = options

  <Group
    value={form.getFieldValue(item)}
    disabled={false}
    onChange={({ target: { value } }) ->
      form.setFieldsValue({ [item]: value }) if form
      value
    }
  >
    { selectOptions.map(({ label, value })->
        <Radio
          key={label}
          name={"radio-button" + item}
          value={value}
          disabled={false}
          style={if vertical then { display: 'block', height: '30px', lineHeight: '30px' }}
        >
          { label }
        </Radio>
    )}
  </Group>
